module.exports = __webpack_public_path__ + "img/mc.254ba201.svg";